import React from 'react';
import Hero from './sections/Hero';
import Services from './sections/Services';
import AboutUs from './sections/AboutUs'
import Footer from './sections/Footer';
import './App.css';

function App() {
  return (
    <div>
      
      <Hero />
      <Services />
      <AboutUs />
       <Footer />
      {/* Add more sections as needed */}
    </div>
  );
}

export default App;
